"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BmInputFieldElement = void 0;

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _validators = require("../../../validators");

var _utils = require("../../../../utils");

var _inputRenderer = require("./input-renderer");

var _itemFactory = require("../item-engine/item-factory");

var _itemRenderer = require("../item-engine/item-renderer");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t:host {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<style>\n\t\t\t\tbm-field {\n\t\t\t\t\tvisibility: hidden;\n\t\t\t\t}\n\t\t\t</style>\n\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t", "\n\t\t\t<bm-field\n\t\t\t\t.name=\"", "\"\n\t\t\t\t.label=\"", "\"\n\t\t\t\t.description=\"", "\"\n\t\t\t\t.errors=\"", "\"\n\t\t\t\t?required=\"", "\"\n\t\t\t\t?editable=\"", "\">\n\t\t\t\t", "\n\t\t\t</bm-field>\n\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["", ""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span>", "</span>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmInputFieldElement = /*#__PURE__*/function (_BmInputElement) {
  (0, _inherits2.default)(BmInputFieldElement, _BmInputElement);

  var _super = (0, _createSuper2.default)(BmInputFieldElement);

  function BmInputFieldElement() {
    (0, _classCallCheck2.default)(this, BmInputFieldElement);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmInputFieldElement, [{
    key: "render",
    value: function render() {
      if (!this.info) return this.html(_templateObject());

      if (this.readonly) {
        return this.renderReadonlyInput();
      }

      return this.renderInput();
    }
  }, {
    key: "renderReadonlyInput",
    value: function renderReadonlyInput() {
      var empty = !(0, _utils.isDefined)(this.value);

      if (empty) {
        return this.renderEmptyReadonlyInput();
      }

      return this.renderDefinedReadonlyInput();
    }
  }, {
    key: "renderEmptyReadonlyInput",
    value: function renderEmptyReadonlyInput() {
      var placeholder = this.readonlyPlaceholder;
      return placeholder ? this.renderPlaceholder(placeholder) : this._renderEmptyReadonlyInput();
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder(placeholder) {
      var placeholderTemplate = this._renderPlaceholder(placeholder);

      return this.renderLabeledTemplate(placeholderTemplate);
    }
  }, {
    key: "_renderPlaceholder",
    value: function _renderPlaceholder(placeholder) {
      return this.html(_templateObject2(), placeholder);
    }
  }, {
    key: "_renderEmptyReadonlyInput",
    value: function _renderEmptyReadonlyInput() {
      return this.renderInput();
    }
  }, {
    key: "renderDefinedReadonlyInput",
    value: function renderDefinedReadonlyInput() {
      var labelConfig = this.readonlyLabel;

      if (labelConfig) {
        var labelItem = (0, _itemFactory.createItem)(labelConfig, null, null, this.value);
        return this.html(_templateObject3(), (0, _itemRenderer.renderItem)(labelItem));
      }

      return this.renderInput();
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var template = this._renderInput();

      return this.renderLabeledTemplate(template);
    }
  }, {
    key: "renderLabeledTemplate",
    value: function renderLabeledTemplate(content) {
      var label = this.label;
      return label ? this._renderLabeledTemplate(this.name, label, content) : content;
    }
  }, {
    key: "_renderLabeledTemplate",
    value: function _renderLabeledTemplate(name, _ref, content) {
      var label = _ref.label,
          description = _ref.description,
          hiddenField = _ref.hiddenField;
      return this.html(_templateObject4(), this._setCustomProperty(hiddenField), name, label, (0, _element.ifDefined)(description), this.errors, this.required, this.editable, content);
    }
  }, {
    key: "_setCustomProperty",
    value: function _setCustomProperty(value) {
      return value ? this.html(_templateObject5()) : null;
    }
  }, {
    key: "name",
    get: function get() {
      return this.info.name;
    }
  }, {
    key: "label",
    get: function get() {
      var _this$info;

      return ((_this$info = this.info) === null || _this$info === void 0 ? void 0 : _this$info.options.label) ? typeof this.info.options.label === 'string' ? {
        label: this.info.options.label,
        hiddenField: this.info.options.hiddenField
      } : this.info.options.label : {
        label: null
      };
    }
  }, {
    key: "errors",
    get: function get() {
      return this.hideErrors ? undefined : (0, _validators.getInputErrors)(this.info);
    }
  }, {
    key: "hideErrors",
    get: function get() {
      return Boolean(this.info.hideErrors);
    }
  }, {
    key: "readonlyPlaceholder",
    get: function get() {
      var readonly = this.info.options.readonly;
      return readonly === null || readonly === void 0 ? void 0 : readonly.placeholder;
    }
  }, {
    key: "readonlyLabel",
    get: function get() {
      var readonly = this.info.options.readonly;
      return readonly === null || readonly === void 0 ? void 0 : readonly.displayAsLabel;
    }
  }, {
    key: "required",
    get: function get() {
      var _context;

      return !this.disabled && Boolean(this.info.options.validators) && Boolean((0, _find.default)(_context = this.info.options.validators).call(_context, function (v) {
        return v.type === _validators.ValidatorType.required;
      }));
    }
  }, {
    key: "editable",
    get: function get() {
      return !(this.disabled || this.readonly);
    }
  }, {
    key: "readonly",
    get: function get() {
      return (0, _validators.isReadonlyInput)(this.info);
    }
  }, {
    key: "disabled",
    get: function get() {
      return Boolean(this.info.disabled);
    }
  }, {
    key: "value",
    get: function get() {
      return this.info.value;
    }
  }], [{
    key: "styles",
    get: function get() {
      return (0, _element.css)(_templateObject6());
    }
  }]);
  return BmInputFieldElement;
}(_inputRenderer.BmInputElement);

exports.BmInputFieldElement = BmInputFieldElement;
